import { render, staticRenderFns } from "./leave_history.vue?vue&type=template&id=62713dfc&scoped=true&"
import script from "./leave_history.vue?vue&type=script&lang=js&"
export * from "./leave_history.vue?vue&type=script&lang=js&"
import style0 from "./leave_history.vue?vue&type=style&index=0&id=62713dfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62713dfc",
  null
  
)

export default component.exports